import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import FoodCategoryList from './FoodCategoryList';

interface FoodCategoryMenuProps {
    restaurantOfferStore: RestaurantOfferStore
}

const FoodCategoryMenu: React.FC<FoodCategoryMenuProps> = observer(({ restaurantOfferStore }) => {
    return (
        <Box maxWidth={200} minWidth={200} width={"100%"} mr={2.5}>
            <FoodCategoryList restaurantOfferStore={restaurantOfferStore} />
        </Box>
    )
})

export default FoodCategoryMenu;